import { RootState } from "../../core/rootReducers";
import { RespyCalibrationManagementState } from "./respyCalbrationManagementSlice";

export function selectRespyCalibrationsState(
	state: RootState
): RespyCalibrationManagementState {
	return state.respyCalibrationManagement as RespyCalibrationManagementState;
}

export function selectRespyCalibrationIsLoading(state: RootState) {
	return selectRespyCalibrationsState(state).loading;
}

export function selectRespyCalibrationError(state: RootState) {
	return selectRespyCalibrationsState(state).error;
}

export function selectRespyCalibrationSites(state: RootState) {
	return selectRespyCalibrationsState(state).sitesAndCalibrations;
}
